export default class Promotion {
	private promo_L = document.querySelectorAll('.promotion--masthead')[0];
	private promo_S = document.querySelectorAll('.promotion:not(.promotion--masthead)')[0];
	private oldVisible = false;

	private togglePromo_S(visible:boolean) {
		const value = String(visible && !this.oldVisible);
		this.promo_S.setAttribute('visible', value);
		this.oldVisible = visible;
	}
	constructor() {
		if (this.promo_S) {
			this.promo_S.querySelectorAll('.promotion__close')[0].addEventListener('click', () => {
				this.promo_S.classList.add('promotion--closed');
			});
		}

		if (!this.promo_L) {
			return;
		}

		let observer = new IntersectionObserver(entries => {
			this.togglePromo_S(entries[0].intersectionRatio == 0);
		});

		if (this.promo_L) {
			observer.observe(this.promo_L);
		}
	}
}
